import * as React from 'react';
import { useRouter } from 'next/router';
import type { Product, WithContext } from 'schema-dts';

import { SanityHeroProduct } from '#/lib/sanity/queries/sections';
import { extractSlugFromRouter } from '#/lib/utils';

import { schemaOrganization } from './consts';
import { RenderSEOSchema } from './Render';

// TODO: Fetch aggregateRating from G2
// Omit Offer until we have a real price — empty/zero offers fail validators.
export function ProductSchema({
  productTitle,
  bodyCopy,
  headline,
  productIcon,
  media,
}: SanityHeroProduct) {
  const { query } = useRouter();
  const slug = extractSlugFromRouter(query);

  const url = `https://transcend.io/${slug}`;
  const schemaData: WithContext<Product> = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url,
    },
    url,
    name: productTitle,
    description: bodyCopy ?? headline,
    slogan: headline,
    brand: {
      '@type': 'Brand',
      name: 'Transcend',
      '@id': 'https://transcend.io/#organization',
    },
    manufacturer: schemaOrganization,
    image: [productIcon.url, ...(media?.url ? [media.url] : [])],
    category: 'Software',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.6',
      ratingCount: '111',
    },
  };

  return <RenderSEOSchema schemaData={schemaData} />;
}
